import { computed } from "vue";

/** Returns whether "Search this area" shows, which is for unapplied manual movement only, and its apply. */
export function useFinderMapBoundsControl(props) {
  const visible = computed(() => props.enabled && props.viewport.dirty.value && !props.viewport.auto.value);
  function apply() {
    props.viewport.apply();
  }
  return { visible, apply };
}
